module.exports = __webpack_public_path__ + "static/media/electric_hum.147f76b5.png";